import { Component, OnInit, Input, Output, ViewChild, TemplateRef, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReportService } from '../../../services/index';
import { GridOptions } from '../../../common/ag-grid/ag-grid.model';
@Component({
    selector: 'app-report-lrs',
    styleUrls: ['./lrs.component.scss'],
    templateUrl: './lrs.component.html'
})
export class LRSReportComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input('tabID') tabID: string;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();
    order_no: any = '';
    loading = false;
    menu: any;
    coreGang = [];
    data: any = {

    };
    detail: any = {};
    row = [];
    filter: any = {
        core_gang : 'ALL',
        groupby : 'invoice'
    };
    gridOptions: any;
    columnDefs: any[];
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    columns = [];
    rowData: any[] = [];
    orderList:any = [];
    toggleCol = [];
    @ViewChild('tabContent') tabContent;
    @ViewChild('entryContainer') entryContainer;
    @ViewChild('listContainer') listContainer;
    constructor(private service: ReportService, private dp: DatePipe) {
        // this.loadGrid();
        // this.loadReport();
    }
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'invoice_no',
        orderDir: 'asc'
    };
    printConfig: any = {
        title: 'Order Form Stock',
        columns: [],
        rows: []
    };

    ngOnInit(): void {
        if(this.menu.param == 'GangCore'){
            this.coreGang = ['CORE','GANG'];
            this.filter.core_gang = "CORE";
          }else{
            this.coreGang = ['NEW','ALL'];
            this.filter.core_gang = "ALL";
          }
     this.getColumns();
     this.toggleCol = Object.assign({}, this.columns);

    }

   
    getColumns() {
        
        this.columns = [
         {name: 'SNo',prop: 'sno',type:'sno', minWidth: 80,maxWidth: 80,width: 80, sortable: false,toggle: true,cellClass: 'text-center',headerClass:'text-center'},
         {name: 'Transport',prop: 'transport', minWidth: 130,maxWidth: 130,width: 130,headerClass:'text-center' },  
         {name: 'Party',prop: 'party_name', minWidth: 130,maxWidth: 130,width: 130,headerClass:'text-center' },
            {name: 'Inv.No',prop: 'invoice_no',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100,headerClass:'text-center' },
            {name: 'Inv Date',prop: 'invoice_date',cellClass: 'text-center', minWidth: 120,maxWidth: 120,width: 120,headerClass:'text-center' },
            {name: 'Private Mark',prop: 'pvt_mark',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100,headerClass:'text-center' },
            {name: 'Bales',prop: 'no_of_bales',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100,headerClass:'text-center' },
            {name: 'Meters',prop: 'totalqty',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100,headerClass:'text-center' },
            {name: 'Amount',prop: 'totalamt',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100,headerClass:'text-center' },
        ];


        this.gridOptions = {
            columns: this.columns,
            loading: true,
            data: []
        }
        // this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
    }
    applyFilter(){
        this.filter.groupby = "invoice";
        this.filter.inv_id = '';
        this.loadReport();
    }
    onCellClick(event){
        this.filter.groupby = "design_no";
        this.filter.inv_id = event.row.inv_id;
        this.loadReport();
    }
    loadReport() {
        let params = {
            start: `${this.page.offset * (this.page.limit + 1)}`,
            limit: `${this.page.limit}`,
            page:'1',
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter:JSON.stringify(this.filter),
            order_no: this.order_no
        };
        // this.loading = true;
        // this.data = {};
        this.isLoadMask = this.service
        .getLRStockReport(params)
        .then((res: any) => {
            
            if (res.success) {
                this.loadingIndicator = false;
           this.page.count = res.totCnt;
           this.orderList = res.data;
                // this.data = res;
                // this.detail = res.detail;
                // this.gridOptions.setData(res.data);
                this.gridOptions = {
                    cols: res.cols,
                    columns: res.columns,
                    data: res.data,
                    loading: false,
                }
            }
            this.loading = false;
        }).catch((err) => {
            this.loading = false;
        });
    }
    // loadGrid() {
    //     const columns: any[] = [{
    //         headerName: 'Transport',
    //         width:150,
    //         maxWidth:150,
    //         minWidth:150
    //     }, {
    //         headerName: 'Party',
    //         field: 'party_name',
    //     },{
    //         headerName: 'Inv.No',
    //         field: 'invoice_no',
    //         width:100,
    //         maxWidth:100,
    //         minWidth:100
    //     },{
    //         headerName: 'Lr No',
    //         field: 'lr_no',
    //         width:120,
    //         maxWidth:150,
    //         minWidth:150
    //     },{
    //         headerName: 'Lr Date',
    //         field: 'lr_date',
    //         width:120,
    //         maxWidth:120,
    //         minWidth:120
    //     },{
    //         headerName: 'Inv Date',
    //         field: 'invoice_date',
    //         width:120,
    //         maxWidth:120,
    //         minWidth:120
    //     }, 
    //      {
    //         headerName: 'Private Mark',
    //         field: 'pvt_mark',
    //         width:150,
    //         maxWidth:150,
    //         minWidth:150
    //     },
    //     {
    //         headerName: 'Bales',
    //         field: 'no_of_bales',
    //         width:85,
    //         maxWidth:85,
    //         minWidth:85
    //     }, {
    //         headerName: 'Meters',
    //         field: 'totalqty',
    //         width:120,
    //         maxWidth:120,
    //         minWidth:120,
    //         sumamry: 'sum',
    //     }, {
    //         headerName: 'Amount',
    //         width:120,
    //         maxWidth:120,
    //         minWidth:120,
    //         field: 'totalamt',
    //         summary: 'sum',
    //     }];
    //     this.columnDefs = columns;
    //     this.rowData = [];
    //     this.gridOptions = new GridOptions({
    //         floatingBottomRowData: [{
    //         }],
    //         columnDefs: this.columnDefs,
    //         rowData: this.rowData,
    //     });
    //     console.log('grid cols', columns);
    // }
    // getListContainerStyle() {
    //     const style: any = {};
    //     let offsetHeight = window.innerHeight;
    //     if (this.tabContent) {
    //         offsetHeight = this.tabContent.nativeElement.offsetHeight;
    //     }
    //     offsetHeight -= 15;
    //     if (this.listContainer) {
    //         offsetHeight -= this.listContainer.nativeElement.offsetHeight;
    //     }
    //     style.height = offsetHeight + 'px';
    //     return style;
    // }
    onbackbutton(){
        this.getColumns();
    }
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.loadReport();
    }
    // onChangePageSize(limit) {
    //     this.page.limit = 10000;
    //     //this.getSalesinvReport();
    // }
    // sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    //     // there will always be one "sort" object if "sortType" is set to "single"
    //     this.page.orderDir = sortInfo.sorts[0].dir;
    //     this.page.orderBy = sortInfo.sorts[0].prop;
    //    // this.getSalesinvReport();
    // }
    // getFormattedDate(so_date) {
    //     return this.dp.transform(new Date(so_date), 'dd-MM-yyyy');
    // }

    // exportToExcel($event) {

    // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/reportlist/lr-stock/lrs.component.ts